import { mediaQueryLarge, onDocumentLoaded } from '@theme/utilities';

const productInformationGridSelector = '.product-information__grid:not(.product-information--media-none)';
const stockStatusSelector = '.variant-stock-status';
const stockStatusContentSelector = '.variant-stock-status__content';
const minLockedMediaHeight = 300;

/**
 * @param {HTMLElement} grid
 */
function unlockMediaHeight(grid) {
  grid.removeAttribute('data-media-height-locked');
  grid.style.removeProperty('--product-information-locked-media-height');
}

/**
 * @param {HTMLElement} grid
 * @returns {number}
 */
function getDetailsHeight(grid) {
  const details = grid.querySelector('.product-details');
  if (!(details instanceof HTMLElement)) return 0;

  const detailsHeight = details.getBoundingClientRect().height;
  const expandedStockStatuses = details.querySelectorAll(`${stockStatusSelector}[open]`);
  let expandedStockHeight = 0;

  for (const stockStatus of expandedStockStatuses) {
    const content = stockStatus.querySelector(stockStatusContentSelector);
    if (!(content instanceof HTMLElement)) continue;

    const styles = window.getComputedStyle(content);
    const marginBlockStart = Number.parseFloat(styles.marginBlockStart) || 0;
    const marginBlockEnd = Number.parseFloat(styles.marginBlockEnd) || 0;

    expandedStockHeight += content.getBoundingClientRect().height + marginBlockStart + marginBlockEnd;
  }

  return Math.max(Math.round(detailsHeight - expandedStockHeight), minLockedMediaHeight);
}

/**
 * @param {HTMLElement} grid
 */
function lockMediaHeight(grid) {
  if (grid.dataset.mediaHeightLocked === 'true') return;

  const height = getDetailsHeight(grid);
  if (height <= 0) return;

  grid.style.setProperty('--product-information-locked-media-height', `${height}px`);
  grid.dataset.mediaHeightLocked = 'true';
}

/**
 * @param {ParentNode} [root]
 */
function lockProductInformationMedia(root = document) {
  const grids = root.querySelectorAll(productInformationGridSelector);

  for (const grid of grids) {
    if (!(grid instanceof HTMLElement)) continue;

    if (!mediaQueryLarge.matches) {
      unlockMediaHeight(grid);
      continue;
    }

    lockMediaHeight(grid);
  }
}

function scheduleMediaHeightLock() {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => lockProductInformationMedia());
  });
}

/**
 * @param {Event} event
 */
function handleStockStatusToggle(event) {
  const target = event.target;
  if (!(target instanceof HTMLElement) || !target.matches(stockStatusSelector)) return;

  const grid = target.closest(productInformationGridSelector);
  if (!(grid instanceof HTMLElement)) return;

  lockProductInformationMedia(grid.parentElement || document);
}

onDocumentLoaded(scheduleMediaHeightLock);

mediaQueryLarge.addEventListener('change', scheduleMediaHeightLock);
document.addEventListener('toggle', handleStockStatusToggle, true);
document.addEventListener('shopify:section:load', scheduleMediaHeightLock);
